
function convertEventMessageToJSON (incomingData?): Record<string, any> | void {

  if (typeof incomingData === 'object' && !!incomingData?.body) return incomingData

  const data = typeof incomingData === 'string'
    ? incomingData.trim()
    : null
  let JSONData = null

  const isValid = typeof data === 'string' &&
    (data?.length ?? 0) > 0 &&
    !!data.match(/^{.*}$/)
  
  if (isValid) {
    
    try {

      JSONData = JSON.parse(data)

    }
    catch ( e ) {

    }

  }

  return JSONData

}

export default convertEventMessageToJSON
